import React from 'react';
import styled, { css } from 'styled-components';
import theme from 'utils/styles/theme';
import {
	fontFamily,
	textAlign,
	space,
	lineHeight,
	fontWeight,
	letterSpacing,
	color,
	display,
	themeGet
} from 'styled-system';
import { cursor } from 'utils/styles/customStyledSystemProps';
import { Link as GatsbyLink } from 'gatsby';

const styles = css`
   font-size: ${theme.fontSizes[0]};
   line-height: ${theme.lineHeights.copy};
   text-decoration: none;
   
   ${fontFamily}
   ${textAlign}
   ${lineHeight}
   ${fontWeight}
   ${letterSpacing}
   ${space}
   ${cursor}
   ${color}
   ${display}
   
   &:hover, &:focus, &:active {
      color: ${themeGet('colors.client.primary')};
      color: ${props => props.color === 'white' && theme.colors.client.accent}
   }
`;

const GatsbyLinkStyled = styled(GatsbyLink)`
	${styles}
`;

const ExternalLinkStyled = styled.a`
	${styles};
`;

const Link = ({ external, to, ...rest }) => {
	if (external) {
		return <ExternalLinkStyled href={to} {...rest} />;
	} else {
		return <GatsbyLinkStyled to={to} {...rest} />;
	}
};

Link.defaultProps = {
	cursor: 'pointer'
};

export default Link;
